import Text from "../../../Components/Text/Text";
import { ReactComponent as RightTriangleSvg } from "../../../assets/svgs/right-triangle.svg";
import LegacyDevicesImage from "../../../assets/images/legacy-devices.png";
import { useRef } from "react";
import { useWindowScroll } from "../../../hooks/useWindowScroll";

export default function StrengthSection() {
  const ref = useRef();
  const { y, height } = useWindowScroll();

  const { offsetTop: elOffsetTop } = ref?.current || {};
  const boundary = elOffsetTop - height / 1.5;
  const show = y > boundary;

  return (
    <section
      ref={ref}
      className="relative pt-24 pb-52 bg-[#F4F4F4] overflow-hidden"
    >
      <div className="container mx-auto px-4 grid place-items-center gap-8 sm:grid-cols-2">
        <img
          src={LegacyDevicesImage}
          alt="ead"
          className={`m-auto transition-all duration-700 ${
            show ? "" : "opacity-0 translate-y-96"
          }`}
        />
        <div
          className={`mx-auto transition-all duration-700 ${
            show ? "" : "opacity-0 translate-x-96"
          }`}
        >
          <Text type="p" size="lg" className="font-semibold">
            Integrate Your Systems
          </Text>
          <Text type="p" size="md" className="font-semibold my-4">
            Connect your business systems and reduce complexities
          </Text>
          <Text>
            Communications between different systems are increasing essential
            and complex. The foundation of any successful business relies on
            seamless integration. The power of the API-Driven businesses allows
            you to scale and grow at a tremendous speed.
          </Text>
        </div>
      </div>
      <RightTriangleSvg className="transition-all absolute bottom-0 fill-white animate-raise-up w-full" />
    </section>
  );
}
